module.exports = __webpack_public_path__ + "img/violet_064.f898b217.png";